// extracted by mini-css-extract-plugin
export default {"closeBtn":"CloseButton_closeBtn__YHlGj","btn-sm":"CloseButton_btn-sm__noA1H","btn-md":"CloseButton_btn-md__9iEYP","btn-lg":"CloseButton_btn-lg__AgrT6"};